(() => {

  var CollectionBundleHighlightApp = (() => {
    const maxWidth = 1180;
    var setPaddingWidthProperty = () => {
      document.querySelectorAll('[js-collection-bundle-highlight]').forEach(element => {
        element.style.setProperty('--padding-left', (element.clientWidth - maxWidth) / 2 + 'px');
      });
    }
    var initialize = () => {
      window.dispatchEvent(new Event('resize'));
      window.addEventListener('resize', () => {
        setPaddingWidthProperty();
      })
    }
    return {
      init: initialize
    }
  })();


  var AnchorApp = (() => {
    var initialize = () => {
      if (window.location.hash === '#bundles') {
        setTimeout(() => {
          if (window.innerWidth < 960) {
            const bundlesSection = document.querySelector('.product-bundle__mobile');
            if (bundlesSection) {
              window.scrollTo(0, bundlesSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          } else {
            const bundlesSection = document.querySelector('.product-bundle__desktop');
            if (bundlesSection) {
              window.scrollTo(0, bundlesSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          }
        }, 500);
      }
      if (window.location.hash === '#mobile-pdp-size-picker') {
        setTimeout(() => {
          if (window.innerWidth < 960) {
            const targetSection = document.querySelector('.pdp-size-picker-ab-test-b.desktop-hide');
            if (targetSection) {
              window.scrollTo(0, targetSection.getBoundingClientRect().top - 100 + window.scrollY);
            }
          }
        }, 500);
      }
    }
    return {
      init: initialize
    }
  })();


  var PDPSizePickerApp = (() => {
    var reinitializeGallery = () => {
      if (window.productGallerySlider) {
        try {
          window.productGallerySlider.destroy();
          window.productGallerySlider = null;
        } catch (e) {
          console.log('Error destroying main slider:', e);
        }
      }

      const mainSliderElement = document.querySelector("[js-product-main-slider]");
      if (mainSliderElement) {
        // Import Flickity and reinitialize
        if (window.flu && window.flu.chunks && window.flu.chunks.flickity) {
          import(window.flu.chunks.flickity).then(({ Flickity }) => {
            const mainSlider = new Flickity('[js-product-main-slider]', {
              contain: true,
              adaptiveHeight: true,
              prevNextButtons: true,
              wrapAround: false,
              pageDots: false,
              cellalign: 'right'
            });

            let thumbnailSlider;
            if (document.querySelector("[js-product-thumbnail-slider]")) {
              thumbnailSlider = new Flickity('[js-product-thumbnail-slider]', {
                contain: true,
                adaptiveHeight: true,
                prevNextButtons: false,
                wrapAround: false,
                pageDots: false,
                cellalign: 'right',
                draggable: false
              });
            }

            mainSlider.on('select', function(index) {
              let slideIndex = index ? index - 1 : 0;
              const productMeasurementInfoWrapperList = document.querySelectorAll('[js-product-measurement-info-wrapper]');
              if (index === 2) {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.add('d-none');
                });
              } else {
                productMeasurementInfoWrapperList.forEach(element => {
                  element.classList.remove('d-none');
                });
              }
              thumbnailSlider?.select(mainSlider.selectedIndex);
              const mediaDescriptionWrap = document.querySelector("[js-product-media-description-wrap]");
              const mediaDescriptionEls = document.querySelectorAll("[js-product-media-description]");
              index ? mediaDescriptionWrap?.classList.add("active") : mediaDescriptionWrap?.classList.remove("active");
              mediaDescriptionEls?.forEach((item, i) => slideIndex === i ? item.classList.add('active') : item.classList.remove('active'));
            });

            thumbnailSlider?.cells.forEach( slide => {
              slide.element.addEventListener("click", function() {
                const index = this.getAttribute("data-slide-index");
                mainSlider.select(index);
                thumbnailSlider?.select(index);
              })
            });

            // Store reference globally
            window.productGallerySlider = mainSlider;
            
            // Add title click functionality
            const productTitle = document.querySelector(".product__title");
            if (productTitle) {
              // Remove existing listeners
              productTitle.replaceWith(productTitle.cloneNode(true));
              const newProductTitle = document.querySelector(".product__title");
              newProductTitle.addEventListener("click", function() {
                mainSlider.next();
              });
            }
          }).catch(e => {
            console.log('Error initializing Flickity:', e);
          });
        } else {
          // Fallback: try to find Flickity in global scope or wait for it
          setTimeout(() => {
            if (window.Flickity) {
              const mainSlider = new window.Flickity('[js-product-main-slider]', {
                contain: true,
                adaptiveHeight: true,
                prevNextButtons: true,
                wrapAround: false,
                pageDots: false,
                cellalign: 'right'
              });
              window.productGallerySlider = mainSlider;
            }
          }, 100);
        }
      }

      // Reinitialize other gallery functionality
      if (window.theme && window.theme.Product) {
        window.theme.Product.init();
      }
      
      // Dispatch gallery reinit event for other scripts
      document.dispatchEvent(new CustomEvent('gallery:reinit'));
    };

    // Function to update product information on the page without page refresh
    var updateProductInfo = async (productUrl) => {
      try {
        // Show loading state
        const container = document.querySelector('.product__size-picker');
        if (container) container.classList.add('size-picker-loading');
        
        // Fetch the new product page HTML
        const response = await fetch(productUrl);
        const html = await response.text();
        const parser = new DOMParser();
        const newDoc = parser.parseFromString(html, 'text/html');
        
        // Update URL without page refresh
        history.pushState(null, '', productUrl);
        
        // Update page title
        document.title = newDoc.title;
        
        // Update product title in main section
        const currentTitleElement = document.querySelector('.product__title');
        const newTitleElement = newDoc.querySelector('.product__title');
        if (currentTitleElement && newTitleElement) {
          currentTitleElement.innerHTML = newTitleElement.innerHTML;
        }
        
        // Update the size picker titles (both desktop and mobile)
        const currentSizePickerTitles = document.querySelectorAll('.product__size-picker .title');
        const newSizePickerTitles = newDoc.querySelectorAll('.product__size-picker .title');
        currentSizePickerTitles.forEach((currentTitle, index) => {
          if (newSizePickerTitles[index]) {
            currentTitle.innerHTML = newSizePickerTitles[index].innerHTML;
          }
        });
        
        // Update the tag text below the title (both desktop and mobile)
        const currentTagTexts = document.querySelectorAll('.product__size-picker .tag-text');
        const newTagTexts = newDoc.querySelectorAll('.product__size-picker .tag-text');
        currentTagTexts.forEach((currentTagText, index) => {
          if (newTagTexts[index]) {
            currentTagText.innerHTML = newTagTexts[index].innerHTML;
          }
        });
        
        // Update product media gallery completely
        const currentMediaContainer = document.querySelector('.product__media__content--media');
        const newMediaContainer = newDoc.querySelector('.product__media__content--media');
        if (currentMediaContainer && newMediaContainer) {
          currentMediaContainer.innerHTML = newMediaContainer.innerHTML;
          
          // Reinitialize gallery functionality after updating content
          setTimeout(() => {
            reinitializeGallery();
          }, 200);
        }
        
        // Update mobile slider if it exists
        const currentMobileSlider = document.querySelector('.product__media-slider');
        const newMobileSlider = newDoc.querySelector('.product__media-slider');
        if (currentMobileSlider && newMobileSlider) {
          currentMobileSlider.innerHTML = newMobileSlider.innerHTML;
        }
        
        // Update product thumbnails if they exist
        const currentThumbnails = document.querySelector('.product__thumbnails');
        const newThumbnails = newDoc.querySelector('.product__thumbnails');
        if (currentThumbnails && newThumbnails) {
          currentThumbnails.innerHTML = newThumbnails.innerHTML;
        }
        
        // Update product price
        const currentPriceElement = document.querySelector('[data-price]');
        const newPriceElement = newDoc.querySelector('[data-price]');
        if (currentPriceElement && newPriceElement) {
          currentPriceElement.textContent = newPriceElement.textContent;
        }
        
        // Update compare at price
        const currentComparePriceElement = document.querySelector('[data-compare-price]');
        const newComparePriceElement = newDoc.querySelector('[data-compare-price]');
        if (currentComparePriceElement && newComparePriceElement) {
          currentComparePriceElement.innerHTML = newComparePriceElement.innerHTML;
        }
        
        // Update sale badge if exists
        const currentSaleBadge = document.querySelector('[js-data-sale-badge-price]');
        const newSaleBadge = newDoc.querySelector('[js-data-sale-badge-price]');
        if (currentSaleBadge && newSaleBadge) {
          currentSaleBadge.innerHTML = newSaleBadge.innerHTML;
        } else if (currentSaleBadge && !newSaleBadge) {
          currentSaleBadge.style.display = 'none';
        } else if (!currentSaleBadge && newSaleBadge) {
          const priceContainer = document.querySelector('.product__price');
          if (priceContainer) {
            priceContainer.appendChild(newSaleBadge.cloneNode(true));
          }
        }
        
        // Update variant selector
        const currentVariantContainer = document.querySelector('[data-product-variants]');
        const newVariantContainer = newDoc.querySelector('[data-product-variants]');
        if (currentVariantContainer && newVariantContainer) {
          currentVariantContainer.innerHTML = newVariantContainer.innerHTML;
        }
        
        // Update product form
        const currentForm = document.querySelector('form[action*="/cart/add"]');
        const newForm = newDoc.querySelector('form[action*="/cart/add"]');
        if (currentForm && newForm) {
          currentForm.action = newForm.action;
          const currentVariantInput = currentForm.querySelector('input[name="id"]');
          const newVariantInput = newForm.querySelector('input[name="id"]');
          if (currentVariantInput && newVariantInput) {
            currentVariantInput.value = newVariantInput.value;
          }
        }
        
        const currentSmallDesc = document.querySelector('.content-item_text');
        const newSmallDesc = newDoc.querySelector('.content-item_text');
        if (currentSmallDesc && newSmallDesc) {
          currentSmallDesc.innerHTML = newSmallDesc.innerHTML;
        }
        
        const currentMeasurementWrappers = document.querySelectorAll('[js-product-measurement-info-wrapper]');
        const newMeasurementWrappers = newDoc.querySelectorAll('[js-product-measurement-info-wrapper]');
        
        currentMeasurementWrappers.forEach(wrapper => wrapper.remove());
        
        if (newMeasurementWrappers.length > 0) {
          const insertPoint = document.querySelector('.product__media-container .product__media__content--media');
          newMeasurementWrappers.forEach(wrapper => {
            if (insertPoint && insertPoint.parentNode) {
              insertPoint.parentNode.insertBefore(wrapper.cloneNode(true), insertPoint.nextSibling);
            }
          });
        }
        
        const currentDeliveryText = document.querySelector('[js-hb-about-delivery]');
        const newDeliveryText = newDoc.querySelector('[js-hb-about-delivery]');
        if (currentDeliveryText && newDeliveryText) {
          currentDeliveryText.innerHTML = newDeliveryText.innerHTML;
        }
        
        const currentProductJson = document.querySelector('#ProductJson-' + document.querySelector('[data-section-id]').getAttribute('data-section-id'));
        const newProductJson = newDoc.querySelector('#ProductJson-' + newDoc.querySelector('[data-section-id]').getAttribute('data-section-id'));
        if (currentProductJson && newProductJson) {
          currentProductJson.textContent = newProductJson.textContent;
        }
        
        // Update breadcrumbs if they exist
        const currentBreadcrumbs = document.querySelector('.breadcrumbs');
        const newBreadcrumbs = newDoc.querySelector('.breadcrumbs');
        if (currentBreadcrumbs && newBreadcrumbs) {
          currentBreadcrumbs.innerHTML = newBreadcrumbs.innerHTML;
        }
        
        // Trigger custom events
        document.dispatchEvent(new CustomEvent('product:switched', {
          detail: { 
            productUrl: productUrl,
            newDoc: newDoc
          }
        }));
        
        // Also trigger variant change event for measurement info
        const newVariantData = newDoc.querySelector('script[data-variant-json]');
        if (newVariantData) {
          try {
            const variants = JSON.parse(newVariantData.textContent);
            if (variants && variants[0]) {
              document.dispatchEvent(new CustomEvent('product:variant-change', {
                detail: { variant: variants[0] }
              }));
            }
          } catch (e) {
            console.log('Could not parse variant data');
          }
        }
        
      } catch (error) {
        console.error('Error updating product info:', error);
        // Fallback to regular page redirect if something goes wrong
        window.location.href = productUrl;
      } finally {
        // Remove loading state
        const container = document.querySelector('.product__size-picker');
        if (container) container.classList.remove('size-picker-loading');
      }
    };

    var calculateScrollProgress = (container, dragging = false, initialize = false) => {
      if (!container) return;
      const activeImage = container.querySelector('[js-image].active');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      const imageList = container.querySelector('[js-image-list]');
      if (!scrollBar || !imageList) return;
      imageList.scrollTo(activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + imageList.scrollLeft - (imageList.clientWidth - activeImage.clientWidth) / 2, 0);
      if (!dragging) {
        setTimeout(() => {
          scrollBar.style.setProperty('--progress', activeImage.getBoundingClientRect().left - imageList.getBoundingClientRect().left + activeImage.offsetWidth / 2 + 'px');
        }, 150);
        if (!initialize) {
          setTimeout(() => {
            const productUrl = activeImage.getAttribute('data-href');
            if (productUrl) {
              updateProductInfo(productUrl);
            }
          }, 300);
        }
      }
    }
    
    var moveScrollBar = (container, percent, dragging = false) => {
      if (!container) return;
      const totalIndex = parseInt(container.getAttribute('data-total-index')) - 1;
      const unitPercent = 100 / totalIndex;
      let index = 0;
      if (percent <= unitPercent / 2) {
        index = 0;
      } else if (percent > (100 - unitPercent / 2)) {
        index = totalIndex;
      } else {
        for (let i = 1; i <= totalIndex - 1; i++) {
          if (percent > (unitPercent / 2 + unitPercent * (i - 1)) && percent <= (unitPercent / 2 + unitPercent * i)) {
            index = i;
          }
        }
      }
      setCurrentImage(container, container.querySelector(`[js-image][data-index="${index}"]`), dragging);
    }
    
    var setCurrentImage = (container, image, dragging = false) => {
      if (!container || !image) return;
      container.querySelectorAll('[js-image]').forEach(element => {
        element.classList.remove('active');
      });
      image.classList.add('active');
      calculateScrollProgress(container, dragging);
    }
    
    var startDragScroll = (container) => {
      if (!container) return;
      container.classList.add('dragging');
    }
    
    var dragScroll = (container, x) => {
      if (!container || !container.classList.contains('dragging')) return;
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0s');
      let progressValue = x - scrollBar.getBoundingClientRect().left;
      progressValue = (progressValue<0)?0:progressValue;
      progressValue = (progressValue>scrollBar.clientWidth)?(scrollBar.clientWidth):progressValue;
      scrollBar.style.setProperty('--progress', progressValue + 'px');
      moveScrollBar(container, progressValue*100/scrollBar.clientWidth, true);
    }
    
    var endDragScroll = (container) => {
      if (!container || !container.classList.contains('dragging')) return;
      container.classList.remove('dragging');
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.style.setProperty('--transition', '0.3s');
      calculateScrollProgress(container);
    }
    
    var initEachSlider = (container) => {
      if (!container) return;
      const imageList = container.querySelector('[js-image-list]');
      if (imageList && imageList.scrollWidth == imageList.clientWidth) {
        imageList.style.justifyContent = 'space-around';
      }
      calculateScrollProgress(container, false, true);
      container.querySelectorAll('[js-image]').forEach(element => {
        element.addEventListener('click', () => {
          setCurrentImage(container, element);
        });
      });
      const scrollBar = container.querySelector('[js-scroll-bar]');
      if (!scrollBar) return;
      scrollBar.addEventListener('click', (event) => {
        moveScrollBar(container, (event.clientX - scrollBar.getBoundingClientRect().left) * 100 / scrollBar.clientWidth);
      });
      const scrollHandler = container.querySelector('[js-scroll-handler]');
      if (!scrollHandler) return;
      scrollHandler.addEventListener('mousedown', () => {
        startDragScroll(container);
      });
      document.addEventListener('mousemove', (event) => {
        dragScroll(container, event.clientX);
      });
      document.addEventListener('mouseup', () => {
        endDragScroll(container);
      });
      scrollHandler.addEventListener('touchstart', () => {
        startDragScroll(container);
      });
      document.addEventListener('touchmove', (event) => {
        dragScroll(container, event.touches[0].clientX);
      });
      document.addEventListener('touchend', () => {
        endDragScroll(container);
      });
    }
    
    var initialize = () => {
      document.querySelectorAll('[js-pdp-size-picker]').forEach(container => {
        initEachSlider(container);
      });
    }
    
    return {
      init: initialize
    }
  })();


  var ProductMeasurementInfoWrapperApp = (() => {
    var switchElement = (variant_id) => {
      document.querySelectorAll('[js-product-measurement-info-wrapper]').forEach(element => {
        if (element.getAttribute('data-variant-id') == String(variant_id)) {
          element.classList.add('active');
        } else {
          element.classList.remove('active');
        }
      });
    }
    var initialize = () => {
      document.addEventListener('product:variant-change', (event) => {
        switchElement(event.detail.variant.id)
      });
    }
    return {
      init: initialize
    }
  })();


  var App = (() => {
    var initialize = () => {
      CollectionBundleHighlightApp.init();
      AnchorApp.init();
      PDPSizePickerApp.init();
      ProductMeasurementInfoWrapperApp.init();
    }
    return {
      init: initialize
    }
  })();


  document.addEventListener('DOMContentLoaded', () => {
    App.init();
  });

})();